var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoodDiary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#febe10;}.cls-3{fill:#ff75b0;}.cls-4{fill:#d1315c;opacity:0.69;}.cls-5{fill:#f8ffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.22,
    y: 0.67,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.22,
    y: 0.67,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "food_diary_copy_2",
    "data-name": "food diary copy 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bowl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M494.15,221.84v0a9.81,9.81,0,0,0-1.09-.07H109.61a54.23,54.23,0,0,1,6.35-17,54.81,54.81,0,0,1,32.59-25.36c1.1-.31,2.21-.59,3.33-.83v0c.15-.73.32-1.46.49-2.18a84,84,0,0,1,58.41-61c1.12-.33,2.26-.62,3.41-.89h0l.15,0,2.14-.48c.42-.09.84-.18,1.26-.25l.08,0,1-.18c1.06-.19,2.13-.37,3.21-.52.62-.09,1.24-.17,1.87-.24.38,0,.76-.09,1.14-.12.62-.07,1.25-.13,1.88-.18s1.42-.11,2.13-.15l.62,0c.74,0,1.49-.06,2.23-.08h1.88a83,83,0,0,1,29.43,5.33c.82.29,1.62.62,2.42.94l.2.07a1.58,1.58,0,0,0,.26.13l.24.1h0c.51-.43,1-.84,1.57-1.25s1.06-.8,1.61-1.19.93-.65,1.41-1c.64-.42,1.28-.83,1.94-1.23s1.32-.78,2-1.15q.51-.28,1-.54l1-.52,1-.5q.53-.25,1.05-.48c.65-.29,1.3-.56,2-.83.42-.17.84-.33,1.27-.48.73-.27,1.46-.52,2.21-.76l1.12-.35c1.5-.44,3-.83,4.58-1.14.77-.16,1.55-.3,2.34-.43l1.18-.17,1.2-.15c.39-.05.8-.09,1.2-.12l1.18-.1.48,0c.35,0,.71,0,1.07-.06l.91,0,1.23,0h.22A54.78,54.78,0,0,1,349.84,136c.18.33.34.65.51,1a69.71,69.71,0,0,1,87.84,39.35l0,.07s0,0,0,0c.14.33.27.66.39,1h.53l.49,0h.7a54.81,54.81,0,0,1,53.81,44.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M599,424.13a21.93,21.93,0,0,1-21,15.36H24.08a21.93,21.93,0,0,1-21-15.36,21.72,21.72,0,0,1,1.21-16.32L20,375.67l60.62-124,8.31-17,.27-.55a22.12,22.12,0,0,1,6.14-7.58,21.84,21.84,0,0,1,5.67-3.23h0a18.17,18.17,0,0,1,3.61-1,11.2,11.2,0,0,1,2-.31,5.9,5.9,0,0,1,1.26-.1,9.81,9.81,0,0,1,1.09-.07H493.06a9.81,9.81,0,0,1,1.09.07,5.9,5.9,0,0,1,1.26.1,11.2,11.2,0,0,1,2,.31l.15,0a18.06,18.06,0,0,1,3.46,1h0a21.84,21.84,0,0,1,5.67,3.23,22.12,22.12,0,0,1,6.14,7.58l.27.55,8.31,17,60.62,124,15.71,32.14A21.72,21.72,0,0,1,599,424.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M599,424.13a21.93,21.93,0,0,1-21,15.36H24.08a21.93,21.93,0,0,1-21-15.36,21.72,21.72,0,0,1,1.21-16.32L20,375.67H582l15.71,32.14A21.72,21.72,0,0,1,599,424.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M512.23,281.83c12.67,27.21,17.34,51.88,10.43,55.1s-22.79-16.23-35.46-43.45S499.56,254.62,512.23,281.83Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodDiary);
export default __webpack_public_path__ + "static/media/food_diary.ca4c6bce12baf90596e3a065da5e870c.svg";
export { ForwardRef as ReactComponent };